/* Auto-generated from sachin-ig-comments-2026-06-28.json — all 56 public IG comments, 28 Mar → 28 Jun 2026. */
export const ALL_COMMENTS = [
  {
    "id": 0,
    "date": "2026-06-27",
    "owner": "htesh.png",
    "text": "Campus",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Campus",
    "postUrl": "https://www.instagram.com/p/DZVLrLdtrA3/",
    "postCaption": "68% of top Indian universities now run an AI learning platform, up from 42% in 2…"
  },
  {
    "id": 1,
    "date": "2026-06-24",
    "owner": "dubeshruti06",
    "text": "Clone",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Clone",
    "postUrl": "https://www.instagram.com/p/DZhp73PFeBC/",
    "postCaption": "You already know video sells your courses. The problem is every video needs you …"
  },
  {
    "id": 2,
    "date": "2026-06-20",
    "owner": "sharon_daniel21",
    "text": "Ads",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Ads",
    "postUrl": "https://www.instagram.com/p/DXO1YOfAIP0/",
    "postCaption": "ABO vs CBO for EdTech, why ABO is the only way to scale."
  },
  {
    "id": 3,
    "date": "2026-06-20",
    "owner": "chandparakram",
    "text": "Hello Sachin, offer looks solid. I'm a high-ticket closer — work with one operator at a time and go all in. If conversions are something you're working on, worth a quick chat 🙌",
    "likes": 0,
    "replies": 0,
    "category": "inbound",
    "keyword": null,
    "postUrl": "https://www.instagram.com/p/DZnPkKjNJdN/",
    "postCaption": "You spend ninety minutes pouring your best teaching into a webinar, forty people…"
  },
  {
    "id": 4,
    "date": "2026-06-18",
    "owner": "catsofthehub",
    "text": "You should do a night school with @thehubbengaluru",
    "likes": 0,
    "replies": 0,
    "category": "inbound",
    "keyword": null,
    "postUrl": "https://www.instagram.com/p/DZnPkKjNJdN/",
    "postCaption": "You spend ninety minutes pouring your best teaching into a webinar, forty people…"
  },
  {
    "id": 5,
    "date": "2026-06-14",
    "owner": "loki_hatake",
    "text": "Campus",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Campus",
    "postUrl": "https://www.instagram.com/p/DZVLrLdtrA3/",
    "postCaption": "68% of top Indian universities now run an AI learning platform, up from 42% in 2…"
  },
  {
    "id": 6,
    "date": "2026-06-12",
    "owner": "wave_academy_vesu",
    "text": "Face",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Face",
    "postUrl": "https://www.instagram.com/p/DZfeKIgNhbX/",
    "postCaption": "PhysicsWallah just went public at over thirty thousand crore, with revenue near …"
  },
  {
    "id": 7,
    "date": "2026-06-11",
    "owner": "__wasim__r_",
    "text": "Campus",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Campus",
    "postUrl": "https://www.instagram.com/p/DZVLrLdtrA3/",
    "postCaption": "68% of top Indian universities now run an AI learning platform, up from 42% in 2…"
  },
  {
    "id": 8,
    "date": "2026-06-11",
    "owner": "ibrahim.yunus96",
    "text": "Scale",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Scale",
    "postUrl": "https://www.instagram.com/p/DYwaoIIzv-F/",
    "postCaption": "Comment ‘Scale’ to join this Global Edtech Community if you qualify!"
  },
  {
    "id": 9,
    "date": "2026-06-08",
    "owner": "abhinav_king",
    "text": "Campus",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Campus",
    "postUrl": "https://www.instagram.com/p/DZVLrLdtrA3/",
    "postCaption": "68% of top Indian universities now run an AI learning platform, up from 42% in 2…"
  },
  {
    "id": 10,
    "date": "2026-06-07",
    "owner": "iadmasia",
    "text": "Absorb",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Absorb",
    "postUrl": "https://www.instagram.com/p/DZSYv_Nt5vY/",
    "postCaption": "Startup funding fell 27% in a month and EdTech has raised almost nothing all yea…"
  },
  {
    "id": 11,
    "date": "2026-06-07",
    "owner": "dev151287",
    "text": "Hire",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Hire",
    "postUrl": "https://www.instagram.com/p/DYpIC9VgczA/",
    "postCaption": "Your First ₹50K Hire Is Wrong. Three Hires in the Right Order."
  },
  {
    "id": 12,
    "date": "2026-06-07",
    "owner": "dev151287",
    "text": "Cac",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "CAC",
    "postUrl": "https://www.instagram.com/p/DYuUlpJFMeD/",
    "postCaption": "Your Real CAC Is Triple What You Think"
  },
  {
    "id": 13,
    "date": "2026-06-06",
    "owner": "retxsh",
    "text": "Scale",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Scale",
    "postUrl": "https://www.instagram.com/p/DYwaoIIzv-F/",
    "postCaption": "Comment ‘Scale’ to join this Global Edtech Community if you qualify!"
  },
  {
    "id": 14,
    "date": "2026-05-26",
    "owner": "ca.kunalkumar",
    "text": "Own",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Own",
    "postUrl": "https://www.instagram.com/p/DYxG6J3kYPL/",
    "postCaption": "Pause Meta For 30 Days. What Survives Is Your Business."
  },
  {
    "id": 15,
    "date": "2026-05-24",
    "owner": "shivank301192",
    "text": "CAC",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "CAC",
    "postUrl": "https://www.instagram.com/p/DYuUlpJFMeD/",
    "postCaption": "Your Real CAC Is Triple What You Think"
  },
  {
    "id": 16,
    "date": "2026-05-23",
    "owner": "aashish_balpande",
    "text": "Claude",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Claude",
    "postUrl": "https://www.instagram.com/p/DWlpi_VCRAK/",
    "postCaption": "Hiring a massive sales team to do manual cold outreach is a fast way to burn cas…"
  },
  {
    "id": 17,
    "date": "2026-05-22",
    "owner": "anushkapankh",
    "text": "Think",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Think",
    "postUrl": "https://www.instagram.com/p/DYmcGuagWky/",
    "postCaption": "Think about it -sales closer"
  },
  {
    "id": 18,
    "date": "2026-05-22",
    "owner": "im__aditya_19",
    "text": "League",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "League",
    "postUrl": "https://www.instagram.com/p/DYXKhv3kjLF/",
    "postCaption": "Indian EdTech has two leagues. Public unicorns burning VC money, and quiet niche…"
  },
  {
    "id": 19,
    "date": "2026-05-21",
    "owner": "im__aditya_19",
    "text": "ai",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 20,
    "date": "2026-05-19",
    "owner": "kidstuttoo",
    "text": "Funnel",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Funnel",
    "postUrl": "https://www.instagram.com/p/DYfFsFzj3tv/",
    "postCaption": "Most edtech founders blame Google Ads for a revenue plateau. The real fix is alm…"
  },
  {
    "id": 21,
    "date": "2026-05-15",
    "owner": "kunal_shar0789",
    "text": "League",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "League",
    "postUrl": "https://www.instagram.com/p/DYXKhv3kjLF/",
    "postCaption": "Indian EdTech has two leagues. Public unicorns burning VC money, and quiet niche…"
  },
  {
    "id": 22,
    "date": "2026-05-15",
    "owner": "elsadmanoficial",
    "text": "League",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "League",
    "postUrl": "https://www.instagram.com/p/DYXKhv3kjLF/",
    "postCaption": "Indian EdTech has two leagues. Public unicorns burning VC money, and quiet niche…"
  },
  {
    "id": 23,
    "date": "2026-05-03",
    "owner": "jitendrarathore.1",
    "text": "Sir, aapko DM kar rakha hai regarding something. Do check",
    "likes": 0,
    "replies": 0,
    "category": "inbound",
    "keyword": null,
    "postUrl": "https://www.instagram.com/p/DX4V2XaD9cl/",
    "postCaption": "Most founders think they are losing on price. Or content quality. Or production …"
  },
  {
    "id": 24,
    "date": "2026-04-29",
    "owner": "_shivaniii26",
    "text": "AI",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 25,
    "date": "2026-04-29",
    "owner": "sarvar.ali39",
    "text": "Trust",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Trust",
    "postUrl": "https://www.instagram.com/p/DXmU0xxgZMl/",
    "postCaption": "Two people saw the exact same price. One bought immediately. One disappeared for…"
  },
  {
    "id": 26,
    "date": "2026-04-26",
    "owner": "ba_with_rajesh",
    "text": "Ai",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 27,
    "date": "2026-04-25",
    "owner": "urbanreliefshop",
    "text": "Ai",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 28,
    "date": "2026-04-25",
    "owner": "anjali.02_official",
    "text": "AI",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 29,
    "date": "2026-04-25",
    "owner": "premsandri",
    "text": "Ai",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 30,
    "date": "2026-04-23",
    "owner": "mohdmoizmoiz6152",
    "text": "❤️",
    "likes": 1,
    "replies": 0,
    "category": "praise",
    "keyword": null,
    "postUrl": "https://www.instagram.com/p/DXbrcCMDRvd/",
    "postCaption": "Most founders think their revenue is stuck because of their offer or their ads. …"
  },
  {
    "id": 31,
    "date": "2026-04-21",
    "owner": "mohdmoizmoiz6152",
    "text": "Hooks",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "Hooks",
    "postUrl": "https://www.instagram.com/p/DXZR2RpjRDB/",
    "postCaption": "Your Content Dies In 2 Seconds.. Watch till end."
  },
  {
    "id": 32,
    "date": "2026-04-21",
    "owner": "sheenawwww",
    "text": "AI",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 33,
    "date": "2026-04-21",
    "owner": "ashu_0212",
    "text": "Ai",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 34,
    "date": "2026-04-21",
    "owner": "ashu_0212",
    "text": "Ai",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 35,
    "date": "2026-04-21",
    "owner": "rtviksethia",
    "text": "AI",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 36,
    "date": "2026-04-21",
    "owner": "sri.thakur_",
    "text": "ai",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 37,
    "date": "2026-04-20",
    "owner": "asaphandrew",
    "text": "Leads",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "Leads",
    "postUrl": "https://www.instagram.com/p/DXWqQr2DDHN/",
    "postCaption": "Biggest Mistake With Your Leads"
  },
  {
    "id": 38,
    "date": "2026-04-20",
    "owner": "aarif_khan_bgp34",
    "text": "Ai",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 39,
    "date": "2026-04-20",
    "owner": "jonny836727",
    "text": "Ai",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 40,
    "date": "2026-04-20",
    "owner": "dragon.6068678",
    "text": "Ai",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 41,
    "date": "2026-04-20",
    "owner": "godfa.ther009988",
    "text": "Ai",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "AI",
    "postUrl": "https://www.instagram.com/p/DXUVGBzAdjk/",
    "postCaption": "This AI can build full courses now"
  },
  {
    "id": 42,
    "date": "2026-04-13",
    "owner": "0sunitarani3",
    "text": "❤️",
    "likes": 2,
    "replies": 0,
    "category": "praise",
    "keyword": null,
    "postUrl": "https://www.instagram.com/p/DXEdA_8GtnV/",
    "postCaption": "Money loves speed. Wealth loves time. Most people focus on moving fast chasing t…"
  },
  {
    "id": 43,
    "date": "2026-04-08",
    "owner": "food_ball",
    "text": "Scale",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Scale",
    "postUrl": "https://www.instagram.com/p/DW23AGWmrcN/",
    "postCaption": "How a Kindergarten teacher solved EdTech’s biggest problem 🤔"
  },
  {
    "id": 44,
    "date": "2026-04-08",
    "owner": "0sunitarani3",
    "text": "Very good,🙊🙊",
    "likes": 2,
    "replies": 0,
    "category": "praise",
    "keyword": null,
    "postUrl": "https://www.instagram.com/p/DW1GythipTF/",
    "postCaption": "Your SDRs aren't lazy. Your clarity is just terrible. \\n\\n"
  },
  {
    "id": 45,
    "date": "2026-04-07",
    "owner": "saremeducation",
    "text": "Creative",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Creative",
    "postUrl": "https://www.instagram.com/p/DWggCQOjk4Z/",
    "postCaption": "EdTech founders waste hours hyper-segmenting Meta Ad audiences. The truth is, Ad…"
  },
  {
    "id": 46,
    "date": "2026-04-06",
    "owner": "bhaskariitkgp2009",
    "text": "Casestudy",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Casestudy",
    "postUrl": "https://www.instagram.com/p/DWjRfC5jV6G/",
    "postCaption": "Most EdTech founders blame their marketing when they can't scale past 50 Lakhs/m…"
  },
  {
    "id": 47,
    "date": "2026-04-05",
    "owner": "0sunitarani3",
    "text": "❤️ very nice",
    "likes": 3,
    "replies": 0,
    "category": "praise",
    "keyword": null,
    "postUrl": "https://www.instagram.com/p/DWvERXmCbGQ/",
    "postCaption": "Stop trying to be an influencer. Learn to build authority."
  },
  {
    "id": 48,
    "date": "2026-04-04",
    "owner": "mrunaldoiphode1988",
    "text": "Casestudy",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "Casestudy",
    "postUrl": "https://www.instagram.com/p/DWjRfC5jV6G/",
    "postCaption": "Most EdTech founders blame their marketing when they can't scale past 50 Lakhs/m…"
  },
  {
    "id": 49,
    "date": "2026-04-03",
    "owner": "aakritidhawanofficial",
    "text": "Claude",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Claude",
    "postUrl": "https://www.instagram.com/p/DWlpi_VCRAK/",
    "postCaption": "Hiring a massive sales team to do manual cold outreach is a fast way to burn cas…"
  },
  {
    "id": 50,
    "date": "2026-04-02",
    "owner": "yaaassshhh.r",
    "text": "Casestudy",
    "likes": 1,
    "replies": 0,
    "category": "cta",
    "keyword": "Casestudy",
    "postUrl": "https://www.instagram.com/p/DWjRfC5jV6G/",
    "postCaption": "Most EdTech founders blame their marketing when they can't scale past 50 Lakhs/m…"
  },
  {
    "id": 51,
    "date": "2026-04-02",
    "owner": "0sunitarani3",
    "text": "❤️",
    "likes": 2,
    "replies": 0,
    "category": "praise",
    "keyword": null,
    "postUrl": "https://www.instagram.com/p/DWlpi_VCRAK/",
    "postCaption": "Hiring a massive sales team to do manual cold outreach is a fast way to burn cas…"
  },
  {
    "id": 52,
    "date": "2026-04-01",
    "owner": "_loukik_houzwala_",
    "text": "Claude",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "Claude",
    "postUrl": "https://www.instagram.com/p/DWlpi_VCRAK/",
    "postCaption": "Hiring a massive sales team to do manual cold outreach is a fast way to burn cas…"
  },
  {
    "id": 53,
    "date": "2026-04-01",
    "owner": "0sunitarani3",
    "text": "❤️❤️🔥",
    "likes": 2,
    "replies": 0,
    "category": "praise",
    "keyword": null,
    "postUrl": "https://www.instagram.com/p/DWjRfC5jV6G/",
    "postCaption": "Most EdTech founders blame their marketing when they can't scale past 50 Lakhs/m…"
  },
  {
    "id": 54,
    "date": "2026-03-30",
    "owner": "madrid_software_trainings",
    "text": "System",
    "likes": 0,
    "replies": 0,
    "category": "cta",
    "keyword": "System",
    "postUrl": "https://www.instagram.com/p/DWgEjMOj3S3/",
    "postCaption": "AI didn’t kill your business. It exposed it. If your product is just information…"
  },
  {
    "id": 55,
    "date": "2026-03-30",
    "owner": "0sunitarani3",
    "text": "🔥🔥👏",
    "likes": 3,
    "replies": 0,
    "category": "praise",
    "keyword": null,
    "postUrl": "https://www.instagram.com/p/DWeXcgdjSlt/",
    "postCaption": "The secret to Alex Hormozi's launch wasn't the book—it was the high-ticket backe…"
  }
];
